import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthStore } from '../store/auth.store';
import { AuthService } from '../services/auth.service';

/**
 * Guard para la página de registro (`/signup`).
 *
 * Si la configuración `referral_only_registration` está activa, el registro solo
 * se permite a través de un link de referido válido y no usado. El guard lee el
 * código del query param `ref`, lo valida contra el backend y solo deja pasar si
 * es válido; en caso contrario redirige al login. Si la configuración no está
 * activa, el registro queda abierto como hoy.
 */
export const referralGuard: CanActivateFn = async (route) => {
  const authStore = inject(AuthStore);
  const authService = inject(AuthService);
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);

  const config = authStore.appConfig() as any;
  const referralOnly =
    config?.referral_only_registration === true ||
    config?.referral_only_registration === 'true';

  // Registro abierto: comportamiento actual.
  if (!referralOnly) return true;

  const code = route.queryParamMap.get('ref');

  if (!code) {
    snackBar.open('Necesitas un enlace de invitación válido para registrarte.', 'Ok', {
      duration: 5000,
      panelClass: 'mat-snack-error'
    });
    router.navigate(['/login']);
    return false;
  }

  try {
    const { data } = await authService.validateReferralLink(code);
    if (data?.valid) return true;
  } catch {
    // Cae al manejo de error de abajo.
  }

  snackBar.open('El enlace de invitación no es válido o ya fue utilizado.', 'Ok', {
    duration: 5000,
    panelClass: 'mat-snack-error'
  });
  router.navigate(['/login']);
  return false;
};
